import { createSlice } from '@reduxjs/toolkit'
import {
    API_ADD_ADMIN_REFFERRAL_CODE,
    API_EDIT_ADMIN_REFFERRAL_CODE,
    API_LIST_ADMIN_REFFERRAL_CODE,
    API_VIEW_ADMIN_REFFERRAL_CODE,
    API_UPDATE_REFFERRAL_ORDER,
} from '../constants/index'

const initialState = {
    isLoading: false,
    isLoggedIn: false,
    refferalCodeDetails: {},
    refferalCodeList: { refferalCodeList: [], recordsTotal: 0 },
    sidebarShow: true,
    skip: 0,
    limit: 10,
}

// 🌐 API CALLS

export const getRefferalDetail = (data) => ({
    type: 'API',
    payload: {
        url: API_VIEW_ADMIN_REFFERRAL_CODE,
        method: 'POST',
        data,
        hideLoader: false,
        success: (data) => ({
            type: 'getRefferalCodeDetails/success',
            payload: data,
        }),
        error: () => ({
            type: 'getRefferalCodeDetails/fail',
            payload: {},
        }),
    },
})

export const AddRefferalCode = (data) => ({
    type: 'API',
    payload: {
        url: API_ADD_ADMIN_REFFERRAL_CODE,
        method: 'POST',
        data,
        hideLoader: false,
    },
})

export const EditRefferalCode = (data) => ({
    type: 'API',
    payload: {
        url: API_EDIT_ADMIN_REFFERRAL_CODE,
        method: 'PATCH',
        data,
        hideLoader: false,
    },
})

export const ListRefferralCode = (data) => ({
    type: 'API',
    payload: {
        url: API_LIST_ADMIN_REFFERRAL_CODE,
        method: 'POST',
        data,
        hideLoader: false,
        success: (data) => ({
            type: 'getRefferalCode/success',
            payload: data,
        }),
        error: () => ({
            type: 'getRefferalCode/fail',
            payload: {},
        }),
    },
})

// ✅ New: Update Order API
export const UpdateReferralOrder = (data) => ({
    type: 'API',
    payload: {
        url: API_UPDATE_REFFERRAL_ORDER,
        method: 'POST',
        data,
        hideLoader: false,
        success: (data) => ({
            type: 'updateRefferalOrder/success',
            payload: data,
        }),
        error: (error) => ({
            type: 'updateRefferalOrder/fail',
            payload: error,
        }),
    },
})

// 🔧 REDUCER

const RefferalCodeSlice = createSlice({
    name: 'RefferalCodeSlice',
    initialState,
    reducers: {
        loaderChange: (state, action) => {
            state.isLoading = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase('set', (state, action) => {
            state.sidebarShow = action.payload
        })

        builder.addCase('getRefferalCode/success', (state, action) => {
            state.refferalCodeList.refferalCodeList = action.payload.data?.refferalCodeList || []
            state.refferalCodeList.recordsTotal = action.payload.data?.recordsTotal || 0
        })

        builder.addCase('getRefferalCode/fail', (state) => {
            state.refferalCodeList = { refferalCodeList: [], recordsTotal: 0 }
            state.isLoggedIn = false
        })

        builder.addCase('getRefferalCodeDetails/success', (state, action) => {
            state.refferalCodeDetails = action.payload.data
        })

        builder.addCase('getRefferalCodeDetails/fail', (state) => {
            state.refferalCodeDetails = {}
            state.isLoggedIn = false
        })
        builder.addCase('updateRefferalOrder/success', () => { })
        builder.addCase('updateRefferalOrder/fail', () => { })
    },
})

export const { loaderChange } = RefferalCodeSlice.actions
export default RefferalCodeSlice.reducer
